import { CsatRequestSaveBody, CsatRequestSaveBodyAction } from '@types'

const saveCSAT: CsatRequestSaveBody = {
  action: CsatRequestSaveBodyAction.Rate,
  comment: 'comment_1',
  rating: '4',
  user_id: 'user_id_1',
}

export default saveCSAT
